export default (cart, selectedPaymentMethod) => ({
	event: 'paymentSelected',
	paymentMethod: selectedPaymentMethod.type,
	orderId: cart.order.id,
	contentGroup: cart.order.contentGroup
});
